import api from "../axios";
import baseUrl from "../baseUrl";

export default {
  // 注册
  register(params) {
    return api.post(baseUrl + "api/enterprise/register", params);
  },
  // 邀请企业注册
  mobRegister(params) {
    return api.post(baseUrl + "api/enterprise/register/mobile", params);
  },
  // 登录
  login(params) {
    return api.post(baseUrl + "api/enterprise/login", params);
  },
  // 手机号登录
  mobLogin(params) {
    return api.post(baseUrl + "api/enterprise/login/mobile", params);
  },
  //登出
  logout(params) {
    return api.get(baseUrl + "api/enterprise/logout", params);
  },
  getUserInfo() {
    return api.get(baseUrl + `api/enterprise/user/info/get`)
  },
  updateUserInfo(params) {
    return api.post(baseUrl + `api/enterprise/user/info/update`, params)
  },
  updatePassword(params) {
    return api.post(baseUrl + `api/enterprise/chgPassword`, params)
  },
};